export const mutations = {
    set_initSettings(state, value) {
        const defaultState = typeof value === 'object' ? value : JSON.parse(value);
        const getDefaultState = {};
        Object.entries(defaultState.configuration).forEach(entry => {
            const [key, value] = entry;
            return key !== 'configuredVoices' && key !== 'donationHistory' ? getDefaultState[key] = value : null;
        });
        Object.assign(state, getDefaultState);
    },
};
